import React from "react";
import PropTypes from "prop-types";
import { withChartData } from "../../common/chart-data-hoc";
import { withChartConfig } from "../../common/chart-config-hoc";
import { DonutChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { objectToSeries, orderBy } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { getLitigatedChallengedCnt, getChallengedLitigatedCnt, getBreakdownByIndustry, getChallengedCnt } from "../../../services/api-patents";
import { Row, Col, Alert } from "antd";

const propValidation = { query: PropTypes.object };

const COLOR_MAP = {
  Challenged: Colors.blue400,
  Litigated: Colors.blue400,
  "Not Litigated": Colors.grey400,
  "Not Challenged": Colors.grey400,
  "High-Tech": Colors.blue400,
  Medical: Colors.blue200,
  Other: Colors.grey200
};

export const LitigatedChallengedChart = props => {
  const dataFormatter = data => orderBy(objectToSeries(data), ["Not Challenged", "Challenged"]);
  const Chart = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getLitigatedChallengedCnt, props.query));
  return <Chart title="Litigated US Patents" subtitle="By Whether Challenged Or Not" dataFormatter={dataFormatter} colorMap={COLOR_MAP} height={500} scrollable={false} {...props} />;
};
LitigatedChallengedChart.propTypes = propValidation;

export const ChallengedLitigatedChart = props => {
  const dataFormatter = data => orderBy(objectToSeries(data), ["Not Litigated", "Litigated"]);
  const Chart = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getChallengedLitigatedCnt, props.query));
  return <Chart title="Challenged US Patents" subtitle="By Whether Litigated Or Not" dataFormatter={dataFormatter} colorMap={COLOR_MAP} height={500} scrollable={false} {...props} />;
};
ChallengedLitigatedChart.propTypes = propValidation;

export const IndustryChart = props => {
  const dataFormatter = data => orderBy(objectToSeries(data), ["High-Tech", "Medical", "Other"]);
  const Chart = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getBreakdownByIndustry, props.query));
  return <Chart title="Litigated And Challenged US Patents" subtitle="By Industry" dataFormatter={dataFormatter} colorMap={COLOR_MAP} height={500} scrollable={false} {...props} />;
};
IndustryChart.propTypes = propValidation;

export const ChallengedChart = props => {
  const dataFormatter = data => orderBy(objectToSeries(data), ["Not Challenged", "Challenged"]);
  const Chart = withChartConfig(withChartData(makeWidthFlexible(DonutChart), getChallengedCnt, props.query));
  return <Chart title="Active US Grants" subtitle="By Whether Challenged Or Not" dataFormatter={dataFormatter} colorMap={COLOR_MAP} height={500} scrollable={false} {...props} />;
};
ChallengedChart.propTypes = propValidation;

const PTABAndLitigation = props => {
  return (
    <div style={{ width: "100%" }}>
      <Alert type="info" message="Litigated patents only cover US patents that have been asserted in district courts after PTAB was founded (2012-09-16)." />
      <Row style={{ width: "100%", marginTop: 16 }}>
        <Col xl={12} span={24}>
          <LitigatedChallengedChart query={props.filter} />
        </Col>
        <Col xl={12} span={24}>
          <ChallengedLitigatedChart query={props.filter} />
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Col xl={12} span={24}>
          <IndustryChart query={props.filter} />
        </Col>
        <Col xl={12} span={24}>
          <ChallengedChart query={props.filter} />
        </Col>
      </Row>
    </div>
  );
};
PTABAndLitigation.propTypes = {
  filter: PropTypes.object
};

export default PTABAndLitigation;
